import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Payroll list (CLAUDE.md §2.3),
 * mirroring the CRM list stores. Status filter lives in URL-bound page state and
 * stays out of the store — that's a server-driven query param, not a durable
 * user pref.
 */
export type PayrollViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const PAYROLL_VIEW_MODES: PayrollViewMode[] = ['table', 'list', 'cards', 'grouped'];

interface PayrollUiState {
  view: PayrollViewMode;
  setView: (view: PayrollViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-period_start`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const usePayrollUi = create<PayrollUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'finance.payroll:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
